import components from '../../common/_components';
import { _sendRequest } from '../../common/_ajax';
import { _on, _off } from '../../../../../assets/common/_events';
import { _toArray, _getData, _reflow } from '../../../../../assets/common/_core';
import { _createEl } from '../../common/_create-el';
import './deal-create-form.scss';

const blockName = 'deal-create-form';

components.add(`js-${blockName}`, (el) => {
    const numericInputs = _toArray(el.querySelectorAll(`.js-${blockName}__input`));
    const headerEl = el.querySelector(`.js-${blockName}__header`);
    const imageUploadLinkEl = el.querySelector(`.${blockName}__header-image-img_stub`);

    let fileInputEl;

    function updateHeaderImage(data) {
        const imageEl = headerEl.querySelector(`.js-${blockName}__header-image-img`);
        const inputEl = headerEl.querySelector(`.js-${blockName}__header-image-input`);
        const template = _getData(headerEl, 'imageUrl');
        const placeholder = _getData(headerEl, 'imageUrlPlaceholder');

        imageEl.removeAttribute('src');
        _reflow(imageEl);

        imageEl.setAttribute('src', template.replace(placeholder, data.path));
        inputEl.value = data.id;

        headerEl.classList.add('has-image');
    }

    function processUploadError() {
        const errorClassName = `${blockName}__header-upload-error js-${blockName}__header-upload-error`;
        const errorMessage = _getData(headerEl, 'imageUploadingError');

        headerEl.appendChild(_createEl('div', errorClassName, [errorMessage]));
    }

    function uploadFile(file) {
        const uploadingErrorEl = headerEl.querySelector(`.js-${blockName}__header-upload-error`);
        const url = _getData(headerEl, 'imageUploadUrl');
        const formData = new window.FormData();

        formData.append('file', file);
        imageUploadLinkEl.classList.add('disabled');

        if (uploadingErrorEl) {
            uploadingErrorEl.parentNode.removeChild(uploadingErrorEl);
        }

        _sendRequest({
            method: 'POST',
            url,
            data: formData,
        })
            .done((response) => {
                if (response.success === true) {
                    updateHeaderImage(response.data);
                } else {
                    processUploadError();
                }
            })
            .fail(processUploadError)
            .always(() => {
                imageUploadLinkEl.classList.remove('disabled');
            });
    }

    function setupFileInput() {
        if (!fileInputEl) {
            const changeHandler = () => {
                if (fileInputEl && fileInputEl.files.length > 0) {
                    uploadFile(fileInputEl.files[0]);

                    _off(fileInputEl, 'change', changeHandler);

                    fileInputEl.parentElement.removeChild(fileInputEl);
                    fileInputEl = null;

                    setupFileInput();
                }
            };

            fileInputEl = _createEl('input', `${blockName}__file-input`, {
                type: 'file',
                accept: 'image/jpeg, image/png, image/gif',
            });

            _on(fileInputEl, 'change', changeHandler);
            el.appendChild(fileInputEl);
        }
    }

    numericInputs.forEach((inputEl) => {
        _on(inputEl, 'input', (e) => {
            let value = inputEl.value.replace(/[^0-9.]/g, '');
            const parts = value.split('.');

            if (parts.length > 2) {
                value = `${parts[0]}.${parts[1]}`;
            }

            inputEl.value = value;
        });
    });

    _on(imageUploadLinkEl, 'mousedown', setupFileInput, { once: true });
    _on(imageUploadLinkEl, 'click', () => {
        if (!imageUploadLinkEl.classList.contains('disabled')) {
            fileInputEl.click();
        }
    });
});
